export type CalendarDay = {
  date: Date;
  iso: string;
  inCurrentMonth: boolean;
};

/** Une date locale, sans conversion UTC : le calendrier suit le jour vu par Alan. */
export function isoDateLocal(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function monthBounds(month: Date): { from: string; to: string } {
  const year = month.getFullYear();
  const index = month.getMonth();
  return {
    from: isoDateLocal(new Date(year, index, 1, 12)),
    to: isoDateLocal(new Date(year, index + 1, 0, 12)),
  };
}

/** Six semaines stables évitent que le tableau de bord saute en hauteur selon le mois. */
export function buildMonthGrid(month: Date): CalendarDay[] {
  const year = month.getFullYear();
  const index = month.getMonth();
  const first = new Date(year, index, 1, 12);
  const mondayOffset = (first.getDay() + 6) % 7;

  return Array.from({ length: 42 }, (_, position) => {
    const date = new Date(year, index, position - mondayOffset + 1, 12);
    return {
      date,
      iso: isoDateLocal(date),
      inCurrentMonth: date.getMonth() === index,
    };
  });
}
